import React from 'react'
import { icon, icons } from './style.css'

type IconType = keyof typeof icons

interface IconProps extends React.HTMLAttributes<HTMLElement> {
  type: IconType
}

export default function Icon({ type, className, ...rest }: IconProps) {
  return <i className={`${icon} ${icons[type]} ${className || ''}`} {...rest} />
}
